import SiteTypes from "./site.types";

const INITIAL_STATE = {
	loaded: false,
	showMenu: false,
	activeLink: "",
	modalIos: false,
	signFrom: false,
	Province: "11",
	listProvince: "",
	cities: [],
	latLng: [0, 0],
	markerLayer: true,
	tecOrAttr: "Technical",
	accessory: "",
	accessories: "",
	product: "",
	products: "",
	aboutUs: "",
	baseInfo: "",
	education: "",
	info: "",
	countUp: "",
	nearest: "",
	application: "",
	news: "",
	slider: [],
	trackSystem: "",
};

const SiteReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SiteTypes.LOADED:
			return {
				...state,
				loaded: !state.loaded,
			};
		case SiteTypes.TOGGLE_MENU:
			return {
				...state,
				showMenu: !state.showMenu,
			};
		case SiteTypes.CHANGE_ACTIVE_LINK:
			return {
				...state,
				activeLink: action.payload,
			};
		case SiteTypes.TOGGLE_MODAL_IOS:
			return {
				...state,
				modalIos: !state.modalIos,
			};
		case SiteTypes.TOGGLE_SIGN_FORM:
			return {
				...state,
				signFrom: !state.signFrom,
			};
		case SiteTypes.CHANGE_PROVINCE:
			return {
				...state,
				Province: action.payload,
			};
		case SiteTypes.SET_CITIES:
			return {
				...state,
				cities: action.payload,
			};
		case SiteTypes.SET_LATLNG:
			return {
				...state,
				latLng: action.payload,
			};
		case SiteTypes.TOGGLE_MARKER_LAYER:
			return {
				...state,
				markerLayer: !state.markerLayer,
			};
		case SiteTypes.SET_PRODUCT:
			return {
				...state,
				product: action.payload,
			};
		case SiteTypes.SET_PRODUCTS:
			return {
				...state,
				products: action.payload,
			};
		// case SiteTypes.SET_ACCESSORY:
		// 	return {
		// 		...state,
		// 		accessory: action.payload,
		// 	};
		case SiteTypes.SET_ACCESSORIES:
			return {
				...state,
				accessories: action.payload,
			};
		case SiteTypes.TOGGLE_TEC_ATTR:
			return {
				...state,
				tecOrAttr: action.payload,
			};
		case SiteTypes.SET_INFO:
			return {
				...state,
				info: action.payload,
			};
		case SiteTypes.SET_ABOUT_US:
			return {
				...state,
				aboutUs: action.payload,
			};
		case SiteTypes.SET_BASE_INFO:
			return {
				...state,
				baseInfo: action.payload,
			};
		case SiteTypes.SET_EDUCATION:
			return {
				...state,
				education: action.payload,
			};
		case SiteTypes.SET_COUNT_UP:
			return {
				...state,
				countUp: action.payload,
			};
		case SiteTypes.SET_NEAREST:
			return {
				...state,
				nearest: action.payload,
			};
		case SiteTypes.SET_LIST_PROVINCE:
			return {
				...state,
				listProvince: action.payload,
			};
		case SiteTypes.SET_APPLICATION:
			return {
				...state,
				application: action.payload,
			};
		case SiteTypes.SET_NEWS:
			return {
				...state,
				news: action.payload,
			};
		case SiteTypes.SET_SLIDER:
			return {
				...state,
				slider: action.payload,
			};
		case SiteTypes.SET_TRACK_SYS:
			return {
				...state,
				trackSystem: action.payload,
			};
		default:
			return state;
	}
};

export default SiteReducer;
